<template>
    <modal :modal-id="modalId"
        :title="(this.selectedUrl ? $t('edit') : $t('add'))+' '+ $t('task')"
        :preloader="preloader"
        @submit="submit"
        @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
          <div v-if="active === 1">
            <form
              class="mb-0"
              :class="{ 'loading-opacity': preloader }"
              ref="form"
              :data-url="addUrl">
              <!-- <v-tour name="editTaskTour" :steps="steps" ></v-tour> -->
                <div class="form-group row align-items-center">
                  <div class="col-sm-12 task_title_tour">
                    <label for="inputs_title ">{{ $t("title") }}</label>
                    <app-input
                      id="inputs_title"
                      type="text"
                      v-model="task.title"
                      :required="true"
                      placeholder='Enter Title'
                    />
                  </div>
                </div>
                <div class="form-group row align-items-center">
                  <div class="col-sm-12">
                    <label for="inputs_description">{{ $t("description") }}</label>
                    <app-input
                      id="inputs_description"
                      type="textarea"
                      v-model="task.description"
                      placeholder="Short Description About Task"
                      :required="true"
                    />
                  </div>
                </div>
                <div class="form-group row align-items-center">
                  <div class="col-sm-12 task_category_tour">
                    <label for="inputs_email">{{ $t("task_category") }}</label>
                    <app-input
                      id="task_category"
                      type="search-select"
                      :placeholder="$t('select_task_category')"
                      :list="taskCategories"
                      v-model="task.task_category_id"
                      :required="true"
                    />
                    <p v-if="categoryAddShow == false" class="font-italic text-muted">
                      {{ $t("shortcut_category_create") }} <span><a href="#" @click.prevent="addCategory()">{{$t("add_category")}}</a></span>
                    </p>
                    <div v-if="categoryAddShow == true">
                      <div class="d-flex align-items-center">
                        <app-input
                          class="mr-2 flex-grow-1"
                          type="text"
                          placeholder="Enter Category Name"
                          v-model="category_name"/>
                        <button type="submit"
                          class="btn btn-sm btn-primary mr-2"
                          @click.prevent="createCategory()">
                          {{ $t('save') }}
                        </button>
                        <a href="#" class="text-muted" @click.prevent="closeCategory()">
                            <app-icon name="x"/>
                        </a>
                      </div>
                      <small class="text-danger ml-2" v-html="message"></small>
                    </div>
                  </div>
                </div>
                <div class="form-group row align-items-center">
                  <div class="col-sm-12">
                    <label for="inputs_forms">{{ $t("forms") }}</label>
                    <app-input
                      type="multi-select"
                      :isAnimatedDropdown="true"
                      :placeholder="$t('forms')"
                      :list="forms"
                      v-model="task.form_id"
                    />
                    <p v-if="refreshShow == false" class="font-italic text-muted">
                      {{ $t("shortcut_form_create") }} <span><a href="#" @click.prevent="createForm()">{{$t("create_new")}}</a></span>
                    </p>
                    <p v-if="refreshShow == true" class="font-italic text-muted">
                      <a href="#" @click.prevent="refreshForm()">{{$t("refresh")}}</a><span> {{ $t("form_create_refresh") }}</span>                    </p>
                  </div>
                </div>
                <div class="form-group row align-items-center">
                  <div class="col-sm-12">
                    <label>{{ $t("users") }}</label>
                    <app-input
                      type="multi-select"
                      :placeholder="$t('select_user')"
                      :list="users"
                      v-model="task.select_users"
                    />
                    <p class="font-italic text-muted">
                      {{ $t("shortcut_user_create") }} <span><a href="#" @click.prevent="addUser()">{{$t("add_user")}}</a></span>
                    </p>
                  </div>
                </div>
                <div class="form-group row align-items-center">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="form-group">
                      <app-input
                        type="single-checkbox"
                        :list-value-field="$t('task_dependent')"
                        v-model="checked_task_dependent"
                      />
                    </div>
                  </div>
                </div>

                <div
                  class="form-group row align-items-center"
                  v-if="checked_task_dependent">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="form-group">
                      <label>{{ $t("dependent_task") }}</label>
                      <app-input
                        type="search-select"
                        :placeholder="$t('select_dependent_task')"
                        :list="this.panddingTask"
                        v-model="task.dependent_task"
                      />
                    </div>
                  </div>
                </div>
                <div v-for="(date_time,k) in date_time_data" :key="k">
                <div class="row">
                  <div class="col-lg-6 col-md-3 col-sm-12">
                    <div class="form-group">
                      <label>{{ $t("start_date") }}</label>
                      <app-input
                        type="date"
                        :required="true"
                        v-model="date_time.start_date"
                        :placeholder="$t('select_valid_date')"
                      />
              <!-- :min-date="new Date()" -->
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-3 col-sm-12">
                    <div class="form-group">
                      <label>{{ $t("start_time") }}</label>
                      <app-input
                        type="time"
                        :required="true"
                        v-model="date_time.start_time"
                        :placeholder="$t('select_valid_time')"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-3 col-sm-12">
                    <div class="form-group">
                      <label>{{ $t("end_date") }}</label>
                      <app-input
                        type="date"
                        v-model="date_time.end_date"
                        :required="true"
                        :placeholder="$t('select_valid_date')"
                      />
              <!-- :min-date="new Date()" -->

                    </div>
                  </div>
                    <div class="col-lg-6 col-md-3 col-sm-12">
                    <div class="form-group">
                      <label>{{ $t("end_time") }}</label>
                      <app-input
                        type="time"
                        :required="true"
                        v-model="date_time.end_time"
                        :placeholder="$t('select_valid_time')"
                      />
                    </div>
                  </div>       
                </div> 
                  <div class="d-flex justify-content-end" v-if="!task.total_recuring_task">
                    <i class="fas fa-minus-circle fa-2x mr-2" @click.prevent="remove(k)" v-show="k || ( !k && date_time_data.length > 1)"></i>
                    <i class="fas fa-plus-circle fa-2x" @click.prevent="add(k)" v-show="k == date_time_data.length-1"></i>
                  </div>       
                  <div class="row" v-else>
                    <div class="col-lg col-md-12 col-sm-12">
                      <div class="form-group">
                        <label class="text-success">This task has <b>{{ task.total_recuring_task }}</b> Repeated task</label>
                      </div>
                    </div>
                  </div>
                </div>

              <!-- <div class="form-group row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <app-input
                      type="single-checkbox"
                      :list-value-field="$t('repeat')"
                      v-model="checked_repeat"
                    />
                  </div>
                </div>
              </div> -->
              <!-- <div
                class="form-group row align-items-center"
                style="align-items: end"
                v-if="checked_repeat"
              >
                <div class="col-lg-4 col-md-4 col-sm-12">
                  <div class="form-group">
                    <label>{{ $t("repeat_every") }}</label>
                    <app-input type="number" v-model="task.repeat_every" />
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                  <div class="form-group">
                    <label></label>
                    <app-input
                      type="select"
                      :list="duraton"
                      v-model="task.select_duraton"
                    />
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                  <div class="form-group">
                    <label>{{ $t("cycles") }}</label>
                    <app-input type="number" v-model="task.cycles" />
                  </div>
                </div>
              </div> -->
              <div class="form-group row align-items-center">
                <!-- <div class="col-sm-6">
                  <label for="inputs_tags">{{ $t("tags") }}</label>
                  <app-input
                    id="inputs_tags"
                    type="text"
                    v-model="task.tag"
                  />
                </div> -->
                <div class="col-sm-6">
                  <label for="inputs_tags">{{ $t("priority") }}</label>
                  <app-input
                    id="inputs_tags"
                    type="radio"
                    :list="priority"
                    v-model="task.priority"
                  />
                </div>
              </div>
              <div class="form-group row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <app-input
                      type="dropzone"
                      v-model="dropzone_files"
                    />
                    <small class="text-muted font-italic">
                      {{ $t("recommended_dropzone_file_validation") }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="form-group row align-items-center">
                <div
                  class="col-lg-2 col-md-2 col-sm-12"
                  v-for="(val, index) in uploade_files"
                  :key="index">
                  <div class="form-group">
                    <img
                      :src="val.filename"
                      alt="uploaded file"
                      class="img-thumbnail"
                    />
                  </div>
                  <span
                    class="dz-remove"
                    style="cursor: pointer"
                    @click="deletefile(val.id,index)"
                    >Remove file</span
                  >
                </div>
              </div>
            </form>
          </div>
          <div v-if="active === 2">
            <shortcut-user-create :back="backTaskCreate"></shortcut-user-create>
          </div>
            
        </template> 
    </modal>
</template>

<script>
import {FormMixin} from "../../../../../../core/mixins/form/FormMixin";
import AppLibrary from "../../../../../Helpers/AppLibrary";
import { axiosPost, axiosGet, axiosDelete } from "../../../../../Helpers/AxiosHelper";
import {
  GET_TASK_CATEGORIES,
  BUYER_CERTIFICATE_FORMS,
  GET_COMPANY_USERS,
  CREATE_TASK,
  DELETE_UPLOADED_FILE,
  COMPANY_JOB_SITE_TASK_UPDATE,
  UPDATE_TASK,
  TASK_CATEGORY_STORE,
} from "../../../../../Config/ApiUrl";

export default {
    name: "TaskAddEditModal",
    mixins: [FormMixin],
    extends:AppLibrary,
    props: {
        stageId: {},
        modalId: {
            type: String,
            default: 'kanban-view-add-edit-Modal'
        }
    },
    data() {
        return {
          refreshShow: false,
          active: 1,
          cat: {},
          message: '',
          categoryAddShow: false,
          category_name: '',
          // steps: [
          //     {
          //       target: '.task_title_tour',  // We're using document.querySelector() under the hood
          //       content: `Task Title Here`,
          //     },
          //     {
          //       target: '.task_category_tour',  // We're using document.querySelector() under the hood
          //       content: `Task Category Here`,
          //     },
          //   ],
            addUrl: CREATE_TASK,
            preloader: false,
            formData: {},
            checked_task_dependent: false,
            // checked_repeat: false,
            taskCategories: [],
            dropzone_files: [],
            uploade_files: [],
            forms: [],
            inputs: {},
            date_time_data:[{
              start_date: new Date(),
              end_date: new Date(),
              start_time: null,
              end_time: null
            }],
            task: {
                form_id: [],
                select_users: [],
                start_date: new Date(),
                due_date: new Date(),
            },
            users: [],
            priority: [
                {
                id: "high",
                value: "High",
                },
                {
                id: "medium",
                value: "Medium",
                },
                {
                id: "low",
                value: "Low",
                },
            ],
            duraton: [
                { id: "", value: "Choose One" },
                { id: "Day", value: "Day" },
                { id: "Week", value: "Weeks" },
                { id: "Month", value: "Month" },
                { id: "Year", value: "Year" },
            ],
        }
    },
    created(){
        if(this.selectedUrl)
            this.preloader = true;
    },
    methods: {
      addCategory() {
        this.categoryAddShow = true;
      },
      closeCategory() {
        this.categoryAddShow = false;
      },
      createCategory() {
        if (this.category_name == '') {
            this.message = 'Category name is required';
        }
        else {
          this.cat.category_name = this.category_name;
          axiosPost(TASK_CATEGORY_STORE, this.cat)
            .then((res) => {
              this.categoryAddShow = false;
              this.$toastr.s(res.data.message);
              this.getTaskCategories();
              this.category_name = '';
            })
            .catch((error) => {
              
            });
        }
      },
      addUser() {
        this.title = this.$t("add_user");
        this.active = 2;
      },
      backTaskCreate(value) {
        this.getUsers();
        this.active = value;
      },
        afterSuccessFromGetEditData(res) {
            
            // this.formData = res.data;
            this.task = res.data;
            let data = [
              {
              start_date: res.data.start_date,
              end_date: res.data.due_date,
              start_time: res.data.start_time,
              end_time: res.data.end_time
              }
            ]
            // this.date_time_data['start_date'] = res.data.start_date;
            // this.date_time_data['end_date'] = res.data.due_date;
            // this.date_time_data['start_time'] = res.data.start_time;
            // this.date_time_data['end_time'] = res.data.end_time;
            this.date_time_data = data;
            console.log(this.date_time_data );
            console.log(this.date_time_data['start_date']);
            // let task_files = res.data.files;
            this.uploade_files = res.data.taskfiles;
            // this.dropzone_files = task_files;
            // task_files.forEach((task_file) =>
            //     
            //     this.dropzone_files.push(task_file)
            // );
            this.preloader = false;
            this.$tours['editTaskTour'].start();
        },
        beforeSubmit() {
            this.preloader = true;
        },
        add () {
          this.date_time_data.push({
            start_date: null,
            end_date: null,
            start_time: null,
            end_time: null
          })
          
        },
        remove (index) {
          this.date_time_data.splice(index, 1)
        },
        submit() {
            this.date_time_data.map(val => {
              return val.start_date = this.getDateFormatForBackend(
                  val.start_date
                ),
                val.end_date = this.getDateFormatForBackend(
                  val.end_date
                )
            
            }); 
            if (!this.selectedUrl)
            {
                this.task.type = "task";
                this.task.stage_id = this.stageId;
                let formData = new FormData();

                if (this.dropzone_files.length) {
                    this.dropzone_files.forEach((dropzone_file) =>
                    formData.append(`dropzone_file[]`, dropzone_file)
                    );
                }
                this.task.date_time_data = JSON.stringify(this.date_time_data);
                Object.keys(this.task).forEach((key) => {
                    formData.append(key, this.task[key]);
                });
                this.save(formData);
            }
            else
            {
                
                let formData = new FormData();

                if (this.dropzone_files.length) {
                    this.dropzone_files.forEach((dropzone_file) =>
                    formData.append(`dropzone_file[]`, dropzone_file)
                    );
                   }
                this.task.date_time_data = JSON.stringify(this.date_time_data);
                Object.keys(this.task).forEach((key) => {
                    formData.append(key, this.task[key]);
                });

                axiosPost(UPDATE_TASK, formData)
                .then((res) => {
                  this.afterSuccess(res);
                })
                .catch((error) => {
                  this.$toastr.e(error.message);
                })
                .finally(() => {
                  this.preloader = false;
                  this.closeModal();
                });
            }
        },
        afterSuccess(res) {
            this.preloader = false;
            this.hideModal();
            this.$toastr.s(res.data.message);
            this.$emit('afterSubmitDone');
        },
        afterError(){
            this.preloader = false;
            this.closeModal();
        },
        hideModal() {
            $('#' + this.modalId).modal('hide');
        },
        closeModal() {
            this.hideModal();
            this.$emit('close-modal')
        },
        deletefile(id, index) {
        this.uploade_files.splice(index, 1);
        axiosDelete(DELETE_UPLOADED_FILE + "/" + id)
            .then((res) => {
            

            this.$toastr.s(res.data.message);
            })
            .catch((error) => {
            this.$toastr.e(error);
            })
            .finally(() => {});
        },
         getTaskCategories() {
            axiosGet(GET_TASK_CATEGORIES)
                .then((res) => {
                this.taskCategories = res.data;
               
                })
                .catch((error) => {
                
                });
            },
            getUsers() {
            axiosGet(GET_COMPANY_USERS)
                .then((res) => {
                this.users = res.data;
                })
                .catch((error) => {
                
                });
            },
            getForms() {
            axiosGet(BUYER_CERTIFICATE_FORMS)
                .then((res) => {
                this.forms = res.data;
                })
                .catch((error) => {
                
                });
            },
            refreshForm() {
              this.refreshShow = false;
              this.getForms();

            },
            createForm() {
              this.refreshShow = true;
              window.open('/admin/documentlibrary/mydocument', '_blank');
            },
    },
    mounted() {
        $(function () {
        $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
        });
        // this.getTask();
        
        this.getTaskCategories();
        this.getForms();
        this.getUsers();
    },
}
</script>
